import { AssetGroupStatistics } from "~/operations";
import { MetricsEntries } from "~/lib/arrow";
import { useDailyAssetCounts } from "../PriorityFindings/useDailyAssetCounts";
import { useDailyPriorityFindingCounts } from "../PriorityFindings/useDailyPriorityFindingCounts";

export type SpaceSummaryData = {
  spaceId: string;
  workspaceId?: string;
  mrn: string;
  name: string;
  description?: string | null;
  assetGroupStats: Pick<
    AssetGroupStatistics,
    "groupType" | "count" | "listsAssetTypes"
  >[];
  // Pre-fetched metric entries for the space. When present, downstream hooks
  // parse from these instead of issuing their own GetMetrics requests.
  metricsEntries?: MetricsEntries;
};

export type UseSpaceSummaryParams = {
  summaryData: SpaceSummaryData;
};

export function useSpaceSummary({ summaryData }: UseSpaceSummaryParams) {
  const { spaceId, workspaceId, metricsEntries } = summaryData;

  const dailyAssetsCounts = useDailyAssetCounts({
    entityMrn: summaryData.mrn,
    entries: metricsEntries,
  });
  const dailyPriorityFindingsCounts = useDailyPriorityFindingCounts({
    entityMrn: summaryData.mrn,
    entries: metricsEntries,
  });

  const overviewHref = workspaceId
    ? `/space/overview?spaceId=${spaceId}&workspaceId=${workspaceId}`
    : `/space/overview?spaceId=${spaceId}`;

  let inventoryHref = `/space/inventory?spaceId=${spaceId}`;
  if (workspaceId) {
    inventoryHref = `${inventoryHref}&workspaceId=${workspaceId}`;
  }

  const integrationsAddHref = `/space/integrations/add?spaceId=${spaceId}`;
  return {
    ...summaryData,
    dailyAssetsCounts,
    dailyPriorityFindingsCounts,
    overviewHref,
    // TODO: remove these once we decided to remove click from SpaceSummaryAssetGroupButtons
    inventoryHref,
    integrationsAddHref,
  };
}
